import React, { useState, memo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, Book } from 'lucide-react';
const tomos = [{
  id: 1,
  title: 'EL ESCUDO AMBIENTAL — El Hogar Como Primera Línea de Defensa',
  subtitle: 'La base que define todo el sistema',
  desc: 'Protocolos completos para convertir el dormitorio de tu hijo en un ambiente que no dispara crisis. Control de humedad, eliminación de ácaros, tratamiento del moho, reemplazo de químicos irritantes y auditoría completa de habitación.',
  bullets: ['Los 7 enemigos invisibles del dormitorio argentino', 'Protocolo Humedad Cero con higrómetro', 'Sistema de 7 días para eliminar el 80% de los ácaros', 'Reemplazo de productos de limpieza irritantes', 'Checklist de Auditoría de 23 puntos']
}, {
  id: 2,
  title: 'BIO-NUTRICIÓN BRONQUIAL — La Alimentación Como Medicina Anti-inflamatoria',
  subtitle: 'Guía completa de qué está comiendo tu hijo que está inflamando sus bronquios desde adentro',
  desc: 'Guía completa de qué está comiendo tu hijo que está inflamando sus bronquios desde adentro, y cómo reemplazarlo con alimentos accesibles en cualquier verdulería argentina.',
  bullets: ['Los 5 Enemigos Blancos del Bronquio', 'Los 7 Superalimentos de Apertura Bronquial', 'El Botiquín de la Cocina (5 remedios caseros seguros)', 'Plan de Comidas Anti-inflamatorio de 14 días', 'Lista de compras Pulmón Sano']
}, {
  id: 3,
  title: 'GIMNASIA PULMONAR Y CONTROL — Entrenando los Pulmones Para que Sean más Fuertes que el Asma',
  subtitle: 'Manual de ejercicios y juegos respiratorios',
  desc: 'Manual de ejercicios y juegos respiratorios para que tu hijo aprenda a respirar diferente, a calmar el broncoespasmo con técnicas físicas y a hacer deporte sin miedo.',
  bullets: ['Reeducación diafragmática en juegos', '10 juegos de soplado para fortalecer los pulmones', 'Técnicas de control al inicio de una crisis', 'Protocolo deportivo Anti-BIE', 'Rutina diaria de 5 minutos']
}];
export const TomosAccordion = () => {
  const [openId, setOpenId] = useState<number | null>(1);
  return <section className="py-10 sm:py-14 md:py-20 bg-cream" data-id="element-268">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-269">
        <div className="text-center mb-6 sm:mb-10" data-id="element-270">
          <h2 className="text-sm font-bold text-brand-orange tracking-widest uppercase mb-2" data-id="element-271">
            CONTENIDO COMPLETO
          </h2>
          <h3 className="text-2xl sm:text-3xl md:text-4xl font-heading font-bold text-gray-900 mb-3 sm:mb-4" data-id="element-272">
            LOS 3 TOMOS
          </h3>
          <p className="text-base sm:text-lg md:text-xl text-gray-600" data-id="element-273">
            Tu hoja de ruta para controlar el asma de tu hijo sin improvisar
          </p>
          <p className="text-xs sm:text-sm text-brand-green font-medium mt-3 sm:mt-4 bg-brand-green/10 inline-block px-4 py-1 rounded-full" data-id="element-274">
            Tocá cada tomo para ver lo que incluye 👆
          </p>
        </div>

        <div className="space-y-3 sm:space-y-4" data-id="element-275">
          {tomos.map(tomo => <div key={tomo.id} className={`bg-white rounded-2xl border overflow-hidden transition-colors ${openId === tomo.id ? 'border-brand-orange shadow-md' : 'border-gray-200 hover:border-brand-orange/50'}`} data-id="element-276">
              <button onClick={() => setOpenId(openId === tomo.id ? null : tomo.id)} className="w-full px-4 sm:px-5 py-4 flex items-center justify-between text-left focus:outline-none" data-id="element-277">
                <div className="flex items-center gap-3 sm:gap-4" data-id="element-278">
                  <div className={`w-10 h-10 sm:w-12 sm:h-12 rounded-xl flex items-center justify-center flex-shrink-0 ${openId === tomo.id ? 'bg-brand-orange text-white' : 'bg-cream-dark text-brand-green'}`} data-id="element-279">
                    <Book size={20} data-id="element-280" />
                  </div>
                  <div data-id="element-281">
                    <h4 className="font-heading font-bold text-base sm:text-lg text-gray-900 leading-tight" data-id="element-282">
                      TOMO {tomo.id}: {tomo.title.split('—')[0]}
                    </h4>
                    <p className="text-xs sm:text-sm text-gray-500 mt-0.5" data-id="element-283">
                      — {tomo.title.split('—')[1]}
                    </p>
                  </div>
                </div>
                <ChevronDown className={`text-gray-400 transition-transform duration-300 flex-shrink-0 ${openId === tomo.id ? 'rotate-180 text-brand-orange' : ''}`} size={20} data-id="element-284" />
              </button>

              <AnimatePresence data-id="element-285">
                {openId === tomo.id && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-286">
                    <div className="px-4 sm:px-6 pb-4 sm:pb-6 pt-2 border-t border-gray-100 ml-0 sm:ml-16" data-id="element-287">
                      <p className="font-semibold text-brand-green mb-2 sm:mb-3 text-sm sm:text-base" data-id="element-288">
                        {tomo.subtitle}
                      </p>
                      <p className="text-gray-600 mb-3 sm:mb-4 leading-relaxed text-sm sm:text-base" data-id="element-289">
                        {tomo.desc}
                      </p>

                      {tomo.bullets.length > 0 && <ul className="space-y-2" data-id="element-290">
                          {tomo.bullets.map((bullet, i) => <li key={i} className="flex items-start gap-2 text-xs sm:text-sm text-gray-700" data-id="element-291">
                              <div className="mt-1.5 w-1.5 h-1.5 bg-brand-orange rounded-full flex-shrink-0" data-id="element-292" />
                              {bullet}
                            </li>)}
                        </ul>}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
};